import { useRef } from 'react';
import type { ChangeEvent, FC } from 'react';
import styled from 'styled-components';
import { hideVisually } from 'polished';

import { Icon, registerIcon, useI18n } from '@pega/cosmos-react-core';
import type { ForwardProps } from '@pega/cosmos-react-core';
import * as pictureIcon from '@pega/cosmos-react-core/lib/components/Icon/icons/picture.icon';

import { useRTEContext } from '../RichTextEditor.context';

import ToolbarButton from './ToolbarButton';

registerIcon(pictureIcon);

const StyledImageInput = styled.input`
  ${hideVisually}
`;

const ImageButton: FC<ForwardProps> = ({ ...props }) => {
  const t = useI18n();
  const { addImage } = useRTEContext();
  const fileInputRef = useRef<HTMLInputElement>(null);

  const onImageInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      addImage(e.target.files[0]);

      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  return (
    <>
      <StyledImageInput
        type='file'
        accept='image/*'
        ref={fileInputRef}
        onChange={onImageInputChange}
      />
      <ToolbarButton
        onClick={() => {
          fileInputRef?.current?.click();
        }}
        tooltip={t('rte_image')}
        label={t('rte_image')}
        {...props}
      >
        <Icon name='picture' />
      </ToolbarButton>
    </>
  );
};

export default ImageButton;
